import { useTranslation } from "react-i18next"; import React from "react";
import LocalizedLink from 'helpers/LocalizeLink';
import { useSelector } from "react-redux";

const HeaderUserMenu = ({ pzMenu, setPzMenu }) => {
    const { t } = useTranslation();
    const user = useSelector((store) => store?.user);

    const menu_items = [
        { name: "Settings", url: "/platform/settings/general" },
        { name: "Payments", url: "/platform/settings/acquisition-history" }];


    const LogOut = () => {
        return (
            <LocalizedLink dti="mk-user-Logout" to={'/price/logout'} className='logato_zone-link text-white text-small text-sm-big text-semibold text-decoration-none'>{t("Log out")}

            </LocalizedLink>);
    };

    return (
        <ul className={'logato_zone-menu text-sm-center p-1 pt-sm-92 pb-sm-20' + (pzMenu === 1 ? ' isActive' : '')}>
            <li className="logato_zone-item text-color-changeable text-semibold text-small text-sm-big px-2 mb-1 mb-sm-12">{user?.name}</li>
            {
                menu_items.map((item, index) => {
                    /* eslint-disable-next-line jsx-a11y/anchor-is-valid */
                    return <li key={'mobile_' + index} className="logato_zone-item px-2 mb-sm-12">
                        <a data-test-id={"mk-user-" + item?.name} href={item.url} className='logato_zone-link text-white text-small text-sm-big text-semibold text-decoration-none'>{item.name}</a>
                    </li>;
                })
            }
            <li className="logato_zone-item px-2"><LogOut /></li>
        </ul>);

};

export default HeaderUserMenu;